import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-14 relative overflow-hidden" data-id="element-171">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-electric/10 blur-[100px] rounded-full pointer-events-none" data-id="element-172"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-gradient-to-b from-petroleum to-graphite border border-electric/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-174">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-electric to-transparent" data-id="element-175"></div>

          <ShieldCheck className="w-20 h-20 text-electric mx-auto mb-6" data-id="element-176" />

          <h2 className="text-3xl md:text-4xl font-extrabold mb-6" data-id="element-177">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-textsecondary mb-8 leading-relaxed" data-id="element-178">
            Abrís los tomos. Los usás en tu casa. Si en 7 días no es exactamente
            lo que esperabas:
            <br data-id="element-179" />
            <br data-id="element-180" />
            <span className="text-white font-medium block" data-id="element-181">
              devolución del 100% sin formularios · sin drama · sin
              explicaciones
            </span>
          </p>

          <div className="inline-flex items-center gap-2 bg-green-500/10 text-green-400 border border-green-500/20 px-6 py-3 rounded-full font-medium" data-id="element-182">
            <ShieldCheck className="w-5 h-5" data-id="element-183" />
            Tasa de devoluciones: menos del 1%
          </div>
        </motion.div>
      </div>
    </section>;
}